
import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

// Lazy load all page components
const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const Products = lazy(() => import('../pages/products/page'));
const Certifications = lazy(() => import('../pages/certifications/page'));
const Partnerships = lazy(() => import('../pages/partnerships/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Quote = lazy(() => import('../pages/quote/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500"></div>
  </div>
);

// Wrapper component for lazy loading
const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<LoadingSpinner />}>
    {children}
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <LazyWrapper><Home /></LazyWrapper>
  },
  {
    path: '/about',
    element: <LazyWrapper><About /></LazyWrapper>
  },
  {
    path: '/services',
    element: <LazyWrapper><Services /></LazyWrapper>
  },
  {
    path: '/products',
    element: <LazyWrapper><Products /></LazyWrapper>
  },
  {
    path: '/certifications',
    element: <LazyWrapper><Certifications /></LazyWrapper>
  },
  {
    path: '/partnerships',
    element: <LazyWrapper><Partnerships /></LazyWrapper>
  },
  {
    path: '/contact',
    element: <LazyWrapper><Contact /></LazyWrapper>
  },
  {
    path: '/quote',
    element: <LazyWrapper><Quote /></LazyWrapper>
  },
  {
    path: '*',
    element: <LazyWrapper><NotFound /></LazyWrapper>
  }
];

export default routes;
